export const brand = {
  name: 'Workium AI',
  tagline: 'Intelligent Work Orchestration',
  accentColor: 'indigo',
  logoInitial: 'W',
  company: 'Workium AI',
  footerText: 'Powered by Workium AI',
}
